import {
  FETCH_DEVICES_REQUEST,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
  UPDATE_DEVICE_REQUEST,
  UPDATE_DEVICE_SUCCESS,
  UPDATE_DEVICE_FAILURE,
  UPDATE_PAYMENT_REQUEST,
  UPDATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_FAILURE,
  SEARCH_DEVICES_REQUEST,
  SEARCH_DEVICES_SUCCESS,
  SEARCH_DEVICES_FAILURE,
  SEARCH_PAYMENTS_REQUEST,
  SEARCH_PAYMENTS_SUCCESS,
  SEARCH_PAYMENTS_FAILURE,
} from './devicesActions';

const initialState = {
  loading: false,
  devicesData: [],
  searchResults: [],
  error: '',
};

const devicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEVICES_REQUEST:
    case UPDATE_DEVICE_REQUEST:
    case UPDATE_PAYMENT_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case FETCH_DEVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        devicesData: [...state.devicesData, ...action.payload],
        error: '',
      };
    case UPDATE_DEVICE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case FETCH_DEVICES_FAILURE:
    case UPDATE_DEVICE_FAILURE:
    case UPDATE_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SEARCH_DEVICES_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_DEVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: action.payload,
        error: '',
      };
    case SEARCH_DEVICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case SEARCH_PAYMENTS_REQUEST:
        return {
          ...state,
          loading: false,
        };
      case SEARCH_PAYMENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          searchResults: action.payload,
          error: '',
        };
      case SEARCH_PAYMENTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
    default:
      return state;
  }
};

export default devicesReducer;
